import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';
import {
    ORFButton as Button
    , OR_RRF_InputField as InputField
    , OR_RRF_Select as Select
    , ORFDropdownCheckbox
} from '../../../../../../common/forms/order-request-form.component';
import { newQuotationActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-quotation.reducer";
import { CustomMultiSelect } from '../../../../../../common/custom-form/custom-multi-select.component';
import { BANDWIDTH_UNIT, MAX_LENGTH } from '../../../../../../../constants/external-constants';
import store from '../../../../../../../store';
import { actions } from 'react-redux-form';
import { ORFSearchSuggestions as SearchSuggestions } from '../../../../../../common/forms/order-request-form.component';
import { createRequestActions } from '../../../../../../../store/external/request-reducer/create-request.reducer';
import { sortVendorAsc } from '../../../../../../../utils/helpers.utils';
import { ORFButton } from '../../../../../../common/forms/order-request-form.component';

class QuotationSubscriptionForm extends Component {
    constructor(props) {
        super(props);
        this.state={
            selectedVendor:[],
            selectedCircuitTypeIds:[],
            selectedContractTermIds:[],
            selectedBandwidthIds:[],
            error:''
        }
    }

    componentDidMount() {
        const {quotationSubscriptionFormA} =this.props;
        
        this.setState({
            selectedVendor: quotationSubscriptionFormA.quotationVendorListIds,
            selectedCircuitTypeIds: quotationSubscriptionFormA.quotationCircuitTypeIds,
            selectedContractTermIds: quotationSubscriptionFormA.quotationContractTermIds,
            selectedBandwidthIds: quotationSubscriptionFormA.quotationBandwidthIds
        });
    }
    
    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleSelectedVendor = (selectedVendors)=>{
        this.setState({selectedVendor:selectedVendors})
    }

    handleSelectedCircuitTypeId = (value) => {
        this.setState({selectedCircuitTypeIds:value})
    }

    handleSelectedContractTermId=(value) => {
        this.setState({selectedContractTermIds:value})
    }

    handleSelectedBandwidthId = (value) =>{
        const { onBandwidthSelect } = this.props;
        var bandwidth = value.sort((a, b) => parseInt(a) - parseInt(b));

        this.setState({selectedBandwidthIds:value})
        onBandwidthSelect(bandwidth);
    }


    handleBandwidthToggle = (value) => {
        this.props.disableAutoScroll(value);
    }

    handleRequestType = (model,value) => {
        const { onRequestTypeSelect } = this.props;

        onRequestTypeSelect(model,value)
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    handleCircuitIdSearch = (searchedValue) => {
        const { fetchQuotationCircuitSuggestions, changeFieldValue } = this.props;
        fetchQuotationCircuitSuggestions(searchedValue);
        changeFieldValue('quotationSubscriptionFormA.quotationCircuitCode', searchedValue);
    }

    render() {
        const {
            //component props
            onClickCancel
            , prevAction
            , nextAction
            // form
            , quotationSubscriptionFormA
            , quotationLocationFormA
            // reducer action
            , onVendorSelect
            , onCircuitTypeSelect
            , onContractTermSelect
            , onBandwidthSelect
            , onSubscriptionSelect
            , onRequestTypeSelect
            , fetchSubscriptionByValue
            , fetchQuotationCircuitSuggestions            
        } = this.props;

        const { requestTypeOptions
            , preferredVendorOptions, allVendorSelected
            , circuitTypeOptions, allCircuitTypeSelected
            , contractTermOptions, allContractTermSelected
            , bandwidthOptions, allBandwidthSelected, showOtherBandwidthField, bandwidthUnit, haveCircuitId } = this.props.quotationRequest;

            const { subscriptionList } = this.props.createRequest;

        let disableSubmit = quotationSubscriptionFormA.quotationRequestTypeId == 0
            || quotationSubscriptionFormA.quotationVendorListIds.length == 0
            || quotationSubscriptionFormA.quotationCircuitTypeIds.length == 0
            || quotationSubscriptionFormA.quotationBandwidthIds.length == 0
            || (haveCircuitId && quotationSubscriptionFormA.quotationCircuitId.length == 0)

        disableSubmit = showOtherBandwidthField ? disableSubmit || quotationSubscriptionFormA.quotationBandwidthOther == '' : disableSubmit;
       
        const sortedVendorOptions = sortVendorAsc(preferredVendorOptions);
        return (
            <div>
                <Form method="post" role="form"
                    model="quotationSubscriptionFormA"
                    onSubmit={nextAction}
                >
                    <div className="quotation-form-container">
                        <Row>
                            <Col xs={12} md={12} lg={12} className='required'>
                                <Select
                                    className="form-control country-label"
                                    label={`${this.toLocaleLanguage('request_type')}`}
                                    options={requestTypeOptions}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    fieldProp='.quotationRequestTypeId'
                                    value={quotationSubscriptionFormA.quotationRequestTypeId}
                                    onChangeAction={this.handleRequestType}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <CustomMultiSelect
                                    options={sortedVendorOptions}
                                    label={`${this.toLocaleLanguage('vendor')}`}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}                                   
                                    requiredField={true}
                                    isDisabled={false} 
                                    fieldProps="quotationSubscriptionFormA.quotationVendorListIds" 
                                    onChange={this.handleSelectedVendor}
                                    selectedOptions={this.state.selectedVendor}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>                                
                                <CustomMultiSelect
                                    options={circuitTypeOptions}
                                    label={`${this.toLocaleLanguage('circuit_type')}`}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    onChange={this.handleSelectedCircuitTypeId}
                                    requiredField={true}
                                    isDisabled={false}
                                    fieldProps="quotationSubscriptionFormA.quotationCircuitTypeIds" 
                                    selectedOptions={this.state.selectedCircuitTypeIds}                                  
                                />
                            </Col>
                        </Row>
                        {
                            haveCircuitId &&
                                <Row>
                                    <Col xs={12} md={12} lg={12} className='subscription_container'>                                    
                                            <SearchSuggestions
                                                value={quotationSubscriptionFormA.quotationCircuitCode}
                                                label={`${this.toLocaleLanguage('circuit_id')}`}
                                                propDisplay={'CircuitCode'}
                                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                                onChangeAction={onSubscriptionSelect}
                                                maxLength={MAX_LENGTH.inputText}
                                                requiredField={true}
                                                searchAction={this.handleCircuitIdSearch}
                                                placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                            />
                                    </Col>
                                </Row>
                        }
                        
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <CustomMultiSelect
                                    options={contractTermOptions}
                                    label={this.toLocaleLanguage('contract_term')}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    onChange={this.handleSelectedContractTermId}
                                    requiredField={false}
                                    isDisabled={false}
                                    fieldProps="quotationSubscriptionFormA.quotationContractTermIds" 
                                    selectedOptions={this.state.selectedContractTermIds}
                                    maxLength={MAX_LENGTH.limit_100}
                                    isNumeric={true}                                       
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>                                
                                <CustomMultiSelect
                                    options={bandwidthOptions}
                                    label={this.toLocaleLanguage('bandwidth')}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    onChange={this.handleSelectedBandwidthId}
                                    requiredField={true}
                                    isDisabled={false}
                                    fieldProps="quotationSubscriptionFormA.quotationBandwidthIds" 
                                    selectedOptions={this.state.selectedBandwidthIds}
                                    isNumeric={true}
                                />
                            </Col>
                        </Row>
                        {showOtherBandwidthField ?
                            <Row>
                                <Col xs={6} md={6} lg={6} className='required'>
                                    <InputField
                                        className="form-control"
                                        type="number"
                                        label={this.toLocaleLanguage('other_bandwidth')}
                                        placeholder={`${this.toLocaleLanguage('enter_text_placeholder')}`}
                                        value={quotationSubscriptionFormA.quotationBandwidthOther}
                                        fieldProp='quotationSubscriptionFormA.quotationBandwidthOther'
                                        maxLength={MAX_LENGTH.limit_100}
                                        isWithDecimal={true}
                                    />
                                </Col>
                                <Col xs={6} md={6} lg={6}>
                                    <Select
                                        className="form-control"
                                        label={`${this.toLocaleLanguage('unit')}`}
                                        options={bandwidthUnit}
                                        requiredField={true}
                                        placeholder={this.toLocaleLanguage('select_placeholder')}
                                        fieldProp='quotationSubscriptionFormA.quotationBandwidthUnitId'
                                        value={quotationSubscriptionFormA.quotationBandwidthUnitId}
                                    />
                                </Col>
                            </Row> 
                            
                            : null
                        }
                        <div className="request-button-continer">
                            <div className="bottom-left">
                                <ORFButton
                                    label={this.toLocaleLanguage('modal_close_cancel_button')}
                                    variant={"light"}
                                    type="button"
                                    action={onClickCancel}
                                />
                            </div>
                            <div className="bottom-right">
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('back')}
                                        variant={"outline-secondary"}
                                        action={prevAction}
                                    />
                                </div>
                                <div>
                                    <Button
                                        label={this.toLocaleLanguage('next_button')}
                                        variant={"primary"}
                                        type={"submit"}
                                        disabled={disableSubmit}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};
export default connect(
    state => {
        const { quotationRequest, translation, createRequest } = state;
        const { quotationSubscriptionFormA } = state.form;
        return {
            quotationRequest
            , quotationSubscriptionFormA
            , createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newQuotationActions, createRequestActions, { changeFieldValue: actions.change }),
            dispatch
        )
)(QuotationSubscriptionForm);